function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.04 13.28l-.92-.9-7.75 7.74.93.93c.78.78 1.59 1.17 2.39 1.17s1.61-.39 2.39-1.17l2.96-2.96c1.59-1.6 1.59-3.21 0-4.81zM10.69 2.93c-1.57-1.57-3.22-1.57-4.79 0L2.93 5.89c-1.56 1.57-1.56 3.22 0 4.79l.92.92 7.75-7.75-.91-.92z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.81 3.94c-1.31 3.27-4.3 7.54-7.15 10.33a5.962 5.962 0 00-5.07-4.96c2.8-2.86 7.1-5.89 10.38-7.21.58-.22 1.16-.05 1.52.31.38.38.56.95.32 1.53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.66 14.27c-.5.49-1 .94-1.48 1.32l-1.97 1.58c-.25.18-.5.33-.78.45 0-.19-.02-.38-.04-.58-.11-.83-.49-1.62-1.16-2.29-.69-.68-1.51-1.07-2.36-1.18-.2-.02-.41-.03-.6-.02.11-.31.28-.6.49-.84l1.56-1.97c.37-.47.8-.95 1.27-1.43 2.6.36 4.66 2.38 5.07 4.96z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.43 17.62c0 1.1-.42 2.15-1.22 2.94-.61.62-1.43 1.04-2.43 1.16l-2.45.27c-1.34.15-2.49-1-2.34-2.35l.27-2.46c.24-2.19 2.07-3.59 4.01-3.63.19-.01.4 0 .6.02.85.11 1.67.5 2.36 1.18.67.67 1.05 1.46 1.16 2.29.02.2.04.39.04.58z"
})));